import request from '@/utils/request'
export default {
	warn_list(data) {
		//预警列表
		return request({
            url: '/api/index/warn_list',
            method: 'post',
            data
        })
	},
    warn_data(data) {
		//预警数据
		return request({
            url: '/api/index/warn_data',
            method: 'post',
            data
        })
	},
    system_shop_list(data) {
		//企业列表
		return request({
            url: '/api/index/system_shop_list',
            method: 'post',
            data
        })
	},
    apply_list(data) {
		//企业申请列表
		return request({
            url: '/api/index/apply_list',
            method: 'post',
            data
        })
	},
    exam_status(data) {
		//审核
		return request({
            url: '/api/index/exam_status',
            method: 'post',
            data
        })
	},
    update_time(data) {
		//修改到期时间
		return request({
            url: '/api/index/update_time',
            method: 'post',
            data
        })
	},
    ortherwarn_list(data) {
		//修改到期时间
		return request({
            url: '/api/index/ortherwarn_list',
            method: 'post',
            data
        })
	},
}


// WEBPACK FOOTER //
// ./src/api/system.js